<div
  class="flex flex-row mt-4"
  [ngClass]="{ 'py-2': fields.fieldDependencies?.length > 0 }"
  [formGroup]="formGroup"
>
  <div class="pb-4 flex items-center justify-between gap-2.5">
    <div class="flex items-center gap-3.5">
      <div class="flex flex-col">
        <span
          class="font-medium text-md text-gray-900"
          [ngClass]="{ required: fields.isRequired }"
        >
          {{ fields.displayName }}
        </span>
        <span class="font-medium text-2sm text-gray-500">
          {{ fields.helpText }}
        </span>
      </div>
    </div>
  </div>
  <div class="switch switch-sm ms-auto mb-3">
    <input
      type="checkbox"
      [checked]="control?.value === true || fields?.value === true"
      (change)="onToggle($event)"
    />
  </div>
</div>
<div
  *ngIf="
    formGroup.get(fields.fieldName)?.touched &&
    formGroup.get(fields.fieldName)?.hasError('required')
  "
  class="text-danger text-sm mt-1 px-3"
>
  This field is required
</div>
